import { Directive, ElementRef,  Input, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { BaseAttribute } from './baseAttribute';

@Directive({
    selector: '[html]'
})
export class HtmlDirective extends BaseAttribute  implements OnInit {

      constructor(private el: ElementRef,private translate: TranslateService ) { super(); }

      @Input('if')        generalIf: any;

      @Input('html-if')   htmlWhere: any;
      
      @Input('param')     param: any;

      @Input ("html")     html:string;

      ngOnInit(): void {

            if ( this.html ) {

                  this.html  = super.ifCheck(this.html, this.htmlWhere, this.generalIf );
                  this.param = super.paramCheck(this.param);
                  this.el.nativeElement.innerHTML = this.translate.instant(this.html,this.param);

                  this.translate.onLangChange.subscribe((event: Event) => {
                        this.el.nativeElement.innerHTML = this.translate.instant(this.html,this.param);
                  });
            }
      }
}
